var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"form"},[_c('b-tabs',{staticClass:"px-2",attrs:{"type":"is-toggle-rounded"}},[_c('b-tab-item',{attrs:{"label":"Add Schools To Existing Project"}},[_c('add-schools')],1),_c('b-tab-item',{attrs:{"label":"Edit Grades And Classes"}},[_c('edit-schools')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }